import {
  cloneListOfCloneable, DataModelBuilder, isSameData, isSameList, SerializationContext, SerializedData,
} from '../../models/dto/dto.js';
import { TicketTemplateCategory } from '../../models/serializable/ticket-template';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class TicketTemplateCategoryComponent extends Component {
  static readonly TYPE_ID: string = 'dda1c6a088a04c2c9c7298e9eb381d28';

  constructor(
    public readonly categories: TicketTemplateCategory[],
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return TicketTemplateCategoryComponent.TYPE_ID;
  }

  static create(args: {
    categories: TicketTemplateCategory[],
  }): TicketTemplateCategoryComponent {
    return new TicketTemplateCategoryComponent(
        args.categories,
    );
  }

  static empty(): TicketTemplateCategoryComponent {
    return new TicketTemplateCategoryComponent(
        new Array<TicketTemplateCategory>(),
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketTemplateCategoryComponent {
    return new TicketTemplateCategoryComponent(
        MapUtils.getList(map, 'categories', (data) => context.fromData<TicketTemplateCategory>(data as SerializedData))
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'categories': this.categories.map((e) => context.toData(e)),
    };
  }

  clone(): this {
    return new TicketTemplateCategoryComponent(
        cloneListOfCloneable(this.categories),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.categories, this.categories, (a, b) => isSameData(a, b));
  }
}

export class TicketTemplateCategoryComponentBuilder extends DataModelBuilder<TicketTemplateCategoryComponent> {
  build(context: SerializationContext, map: SerializedData): TicketTemplateCategoryComponent {
    return TicketTemplateCategoryComponent.fromMap(context, map);
  }
}
